import { Component, OnInit } from '@angular/core';
import { OthersService } from 'src/app/_services/others.service';

@Component({
  selector: 'app-draft-quotation',
  templateUrl: './draft-quotation.component.html',
  styleUrls: ['./draft-quotation.component.scss']
})
export class DraftQuotationComponent implements OnInit {

  dataRfqBoard:any=[]
  publicRFQ:any=[]
  publicRFQLoading:boolean=true

  constructor(
    private othersService: OthersService,
  ) { }

  ngOnInit(): void {
    this.getanyoneViewRfqList()
  }

  getanyoneViewRfqList(){
    

    this.othersService
    .anyoneViewRfqList()
    .subscribe((res:any) => {
      console.log("succes, get data:", res);
      this.publicRFQLoading = false
      
      if(res.data?.anyoneViewRfqList){
        this.publicRFQ = res.data?.anyoneViewRfqList


        this.publicRFQ.forEach((value: any, key: any) => {



          var categoryComma ='';
          if(value.rfqVendorCategory){
            categoryComma = value.rfqVendorCategory.join(", ")
          }
          

          var dataBoard ={
            city:value.rfqDeliveryCity,
            country:value.rfqDeliveryCountry,
            submitQuotationLastDate:value.submitQuotationLastDate,
            totalVendorParticipation:value.totalParticipation,
            procurementName:value.procurementName,
           // rfqState:value.rfqState,
            rfqState:null,
            isAlreadyParticipating:value.isAlreadyParticipating,
            rfqVendorCategory:categoryComma,
            rfqDisplayId:value.rfqDisplayId,
            description:value.description,
            rfqItem:value.rfqItem,
            haveMoreRfqItem:value.haveMoreRfqItem,
            sponsored:false,
            //url:this.redirectUrl(value.rfqId,value.rfqParticipationId,value.quotationId)
            url:'/regis?draftqoutation='+value.rfqId+'&pov=VENDOR'
          }
          console.log('dataBoard : ',dataBoard)
          this.dataRfqBoard.push(dataBoard)


        })
        

      }

      
    });

  }

}
